import { render, staticRenderFns } from "./SendingPage.vue?vue&type=template&id=5b2a3c42&"
import script from "./SendingPage.vue?vue&type=script&lang=js&"
export * from "./SendingPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports